import { useState, useEffect } from "react";
import Logo from "../img/Logo_signcast_big-1080x322.png";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../store/authStore";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  
  const { 
    resetPassword, 
    resetToken,
    isLoading, 
    error, 
    clearError 
  } = useAuthStore();
  
  const navigate = useNavigate();

  // Redirect if no token in state
  useEffect(() => {
    if (!resetToken) {
      navigate('/forgot-password');
    }
  }, [resetToken, navigate]);

  const validatePassword = () => {
    if (newPassword.length < 8) {
      setPasswordError("Password must be at least 8 characters long");
      return false;
    }
    
    if (newPassword !== confirmPassword) {
      setPasswordError("Passwords do not match");
      return false;
    }
    
    setPasswordError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();
    
    if (!validatePassword()) {
      return;
    }
    
    const success = await resetPassword(newPassword);
    
    if (success) {
      // Show success message and redirect to login
      alert("Password has been reset successfully! Please log in with your new password.");
      navigate('/login');
    }
  };

  return (
    <div className="login-container bg-blue-50 w-full h-screen flex justify-center items-center">
      <div className="bg-white w-[420px] h-[500px] rounded-lg shadow-lg">
        <div className="flex flex-row justify-center pt-10">
          <img className="w-52 h-auto" src={Logo} alt="Logo" />
        </div>
        
        <div className="text-center mt-4 mb-2">
          <h2 className="text-xl font-semibold">Set New Password</h2>
          <p className="text-gray-600 text-sm px-10 py-2">
            Create a new password for your account
          </p>
        </div>
        
        <form onSubmit={handleSubmit}>
          {error && (
            <p className="text-red-500 text-[14px] text-center mt-2">{error}</p>
          )}
          
          {passwordError && (
            <p className="text-red-500 text-[14px] text-center mt-2">{passwordError}</p>
          )}
          
          <div className="flex flex-col pl-10">
            <p className="text-black text-[14px] pt-4 pb-2">
              New Password
            </p>
            <input
              className="text-[14px] pl-4 w-[340px] h-[45px] rounded-lg border-2 border-gray-300"
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={8}
            />
          </div>
          
          <div className="flex flex-col pl-10">
            <p className="text-black text-[14px] pt-4 pb-2">
              Confirm Password
            </p>
            <input
              className="text-[14px] pl-4 w-[340px] h-[45px] rounded-lg border-2 border-gray-300"
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          
          <div className="flex flex-col pt-6 p-10 rounded-lg">
            <button
              type="submit"
              disabled={isLoading}
              className="h-[41px] w-full bg-blue-500 text-white text-[14px] font-bold rounded-lg hover:bg-blue-600 transition-colors"
            >
              {isLoading ? "Resetting..." : "Reset Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword; 